import Toast, {ToastProps} from '@submodules/ToastNotification/Toast';

/** Close Icon Component */
import {CloseIcon} from '../../icons';
import SuccessIcon from '@assets/svg/success-icon';
import ErrorIcon from '@assets/svg/error-icon';
import './index.scss';

/** note: toast and alert can be interchangeably used */
interface AlertProps extends ToastProps {
  toastType?:
    | ToastProps['typeofToast']
    | 'default'
    | 'gst-success' /** combining two extra gst hero specific alert type */;
}

function Alert(props: Readonly<Omit<AlertProps, 'typeofToast'>>) {
  const {
    closeFn,
    toastType,
    content,
    id,
    heading,
    isCloseVisible,
    showIcon,
    variant,
    dataTestId,
  } = props;

  /** Switch like statement, which handles the color of the close icon based on the type of the alert */
  const iconColor = {
    success: '#fff',
    warning: '#fff',
    info: '#fff',
    danger: '#fff',
    default: '#fff',
    'gst-success': '#ffffff ',
  };

  /** This functions directs to the module's Toast compoent's types */
  const libraryAlerts = () => {
    if (toastType !== 'default' && toastType !== 'gst-success') {
      return toastType;
    }
    return undefined;
  };

  /** Icon selection based on toastType */
  let alertIcon = undefined;
  if (toastType === 'success') {
    alertIcon = <SuccessIcon />;
  } else if (toastType === 'danger') {
    alertIcon = <ErrorIcon />;
  }

  return (
    <div className={`alert-wrapper ${toastType}`} data-testid='alert-wrapper'>
      {/* Render custom icon if present */}
      {alertIcon && <span className='alert-custom-icon'>{alertIcon}</span>}
      <Toast
        typeofToast={libraryAlerts()}
        content={content}
        id={id}
        dataTestId={dataTestId}
        heading={heading}
        isCloseVisible={isCloseVisible}
        showIcon={showIcon}
        variant={variant}
        closeFn={closeFn}
        closeIcon={
          <CloseIcon fill={iconColor[toastType as keyof typeof toastType]} />
        }
      />
    </div>
  );
}

export default Alert;
